/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLaunchData } from './BaseLaunchData';
import { PearsonTemplate } from './PearsonTemplate';
const LTITemplatePreviewLaunchDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('template_preview_result')],
    ['template', PearsonTemplate],
]), BaseLaunchData);
export class LTITemplatePreviewLaunchData extends BaseLaunchData {
    static decode(input) {
        return LTITemplatePreviewLaunchDataParser.decode(input).map(res => new LTITemplatePreviewLaunchData(res));
    }
    static unsafeDecode(input) {
        return LTITemplatePreviewLaunchData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTITemplatePreviewLaunchDataParser.encode(data);
    }
    static schema() {
        return LTITemplatePreviewLaunchDataParser.schema();
    }
}
